import React from "react";

export default function Skeleton({ width = "100%", height = "1em" }) {
  return (
    <div style={{ width, height, background: "var(--bg-subtle)", borderRadius: 4, overflow: "hidden" }}>
      <div
        style={{
          width: "100%",
          height: "100%",
          animation: "ds-skel 1.5s infinite",
          background: "linear-gradient(90deg, var(--bg-subtle), var(--bg-surface), var(--bg-subtle))",
          backgroundSize: "200% 100%",
        }}
      />
      <style>{"@keyframes ds-skel{0%{background-position:200% 0;}100%{background-position:-200% 0;}}"}</style>
    </div>
  );
}
